
import { DepthCompare, DepthFormat, NormalBlend } from "../CommonRenderTargets";
import { getColorShader } from "./GroundShadowShaders";

export class GroundShadowColorPipeline {

  #renderer;
  #device;

  #pipeline;
  #shader;

  #bindGroupLayouts = [];
  #targets = [];
  #geomStride;

  constructor(renderer, frameLayout, textureLayout, targetFormat, geomStride) {
    this.#renderer = renderer;
    this.#device = renderer.getDevice();
    this.#geomStride = geomStride;

    this.#bindGroupLayouts = [
    frameLayout,
    textureLayout];


    this.#targets.push({
      format: targetFormat,
      blend: NormalBlend
    });

    this.#shader = this.#device.createShaderModule({
      label: 'ground shadow color shader',
      code: getColorShader()
    });

    this.#createPipeline();
  }

  #createPipeline() {
    const sampleCount = this.#renderer.getMSAASampleCount();
    this.#pipeline = this.#device.createRenderPipeline({
      label: 'ground shadow color pipeline',
      layout: this.#device.createPipelineLayout({
        bindGroupLayouts: this.#bindGroupLayouts
      }),
      vertex: {
        module: this.#shader,
        entryPoint: 'vsmain',
        buffers: [
        {
          arrayStride: this.#geomStride * 4,
          attributes: [
          {
            shaderLocation: 0,
            offset: 0,
            format: 'float32x3'
          },
          {
            shaderLocation: 1,
            offset: 12,
            format: 'float32x2'
          }]

        }]

      },
      fragment: {
        module: this.#shader,
        entryPoint: 'psmain',
        targets: this.#targets
      },
      primitive: {
        cullMode: 'back',
        topology: 'triangle-list'
      },
      depthStencil: {
        depthWriteEnabled: false,
        depthCompare: DepthCompare,
        format: DepthFormat
      },
      multisample: {
        count: sampleCount
      }
    });
  }

  /** Recreates the pipeline. Call when MSAA settings change. */
  resetPipeline() {
    this.#createPipeline();
  }

  getPipeline() {
    return this.#pipeline;
  }
}